import React from "react";
import "./WitEarnHome.scss"
import SecondaryButton from "../../components/Button/SecondaryButton";
import { sortByOrderAscending } from "../../helper/helper";

const WitEarnHomeFinance = ({ components }) => {
    const getComponents = (key, component) => {
        console.log(component?.Components, "component?.Components")
        switch (component.ID) {
            case "HeaderText":
                return <div className="WitEarnHomeFinance-header">
                    {component?.Props?.text}
                </div>
            case "HeaderSubText":
                return <div className="WitEarnHomeFinance-subheader">
                    {component?.Props?.text}
                </div>
            case "WitEarnHomeFinanceContainer":
                return <div className="WitEarnHomeFinance-btnCont">
                    {component?.Components?.map((btnComponent, index) => {
                        return (
                            <SecondaryButton key={index} isPrimary={btnComponent?.Props?.isPrimary} buttonText={btnComponent?.Props?.buttonText} width={btnComponent?.Props?.width} />
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="WitEarnHomeFinance">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponents(key, component)

            })}
        </div>
    )
}
export default WitEarnHomeFinance